import { render, staticRenderFns } from "./Serviceinfor.vue?vue&type=template&id=3e67740c"
import script from "./Serviceinfor.vue?vue&type=script&lang=js"
export * from "./Serviceinfor.vue?vue&type=script&lang=js"
import style0 from "./Serviceinfor.vue?vue&type=style&index=0&id=3e67740c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports